

/// <reference path="DocumentTemplate.ts" />

// Generated class LayoutDocumentTemplate_ManagedObject

class LayoutDocumentTemplate_ManagedObject extends DocumentTemplate
{

    // Property: documentType
    set documentType(value:string) {
        this.setValueForKey(value, 'documentType');
    }
    get documentType():string {
        return this.valueForKey('documentType');
    }
    set documentTypePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'documentType');
    }
    get documentTypePrimitiveValue():string {
        return this.primitiveValueForKey('documentType');
    }

    // Property: formatVersion
    set formatVersion(value:number) {
        this.setValueForKey(value, 'formatVersion');
    }
    get formatVersion():number {
        return this.valueForKey('formatVersion');
    }
    set formatVersionPrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'formatVersion');
    }
    get formatVersionPrimitiveValue():number {
        return this.primitiveValueForKey('formatVersion');
    }

    // Property: layoutBody
    set layoutBody(value:string) {
        this.setValueForKey(value, 'layoutBody');
    }
    get layoutBody():string {
        return this.valueForKey('layoutBody');
    }
    set layoutBodyPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'layoutBody');
    }
    get layoutBodyPrimitiveValue():string {
        return this.primitiveValueForKey('layoutBody');
    }

    // Property: name
    set name(value:string) {
        this.setValueForKey(value, 'name');
    }
    get name():string {
        return this.valueForKey('name');
    }
    set namePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'name');
    }
    get namePrimitiveValue():string {
        return this.primitiveValueForKey('name');
    }

    // Property: paperSize
    set paperSize(value:string) {
        this.setValueForKey(value, 'paperSize');
    }
    get paperSize():string {
        return this.valueForKey('paperSize');
    }
    set paperSizePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'paperSize');
    }
    get paperSizePrimitiveValue():string {
        return this.primitiveValueForKey('paperSize');
    }

    // Property: subject
    set subject(value:string) {
        this.setValueForKey(value, 'subject');
    }
    get subject():string {
        return this.valueForKey('subject');
    }
    set subjectPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'subject');
    }
    get subjectPrimitiveValue():string {
        return this.primitiveValueForKey('subject');
    }
}
